var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row "},[_c('div',{staticClass:"col-3"},[_c('bateria')],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('comprarForm')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40833250","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentes/comprar.vue
// module id = null
// module chunks = 